/* eslint-disable */
import { transform } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// material
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  Typography,
  TableContainer,
  CircularProgress,
} from '@mui/material';
// component
import Iconify from '../../../components/Iconify';
import axios from 'axios';
import Services from 'src/service/Services';
import { localdata } from 'src/service/localdata';

// ----------------------------------------------------------------------

export default function UserPermission({
  item,
}) {
  const ref = useRef(null);
  const { id } = item;
  const [mainOpen, setMainOpen] = useState(false);
  const [permissionList, setPermissionList] = useState({});
  const [list, setList] = useState([]);
  const [userPermissions, setUserPermissions] = useState({});
  const [selectedList, setSelectedList] = useState([]);

  const titleCase = (text) => {
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  useEffect(() => {
    if (mainOpen) {
      getPermissions();
    }
  }, [mainOpen])

  const getUserPermissions = () => {
    const userData = localdata.GET_DATA();
    axios.get(Services.PERMISSION() + '/users/' + id, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      }
    }).then(e => {
      setUserPermissions(e.data.results)
      setSelectedList(list.filter(el => {
        if (e.data.results[el.module] === 'All') {
          return true
        } else {
          console.log(el, e.data.results[el.module]?.includes(el.resource), '---')
          return e.data.results[el.module]?.includes(el.resource)
        }
      }).map(e => {
        return {
          userId: id,
          permissionId: e.id
        }
      }));
    })
  }

  const getPermissions = () => {
    const userData = localdata.GET_DATA();
    axios.get(Services.PERMISSION(), {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      }
    }).then(e => {
      setList(e.data.results);
      const result = e.data.results.reduce(function (r, a) {
        r[a.module] = r[a.module] || [];
        r[a.module].push(a);
        return r;
      }, Object.create(null));
      getUserPermissions();
      setPermissionList(result)
    })
  }

  const assignPermission = () => {
    console.log(selectedList)
    const userData = localdata.GET_DATA();
    axios.post(Services.PERMISSION() + '/assign', selectedList, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      }
    }).then(e => {
      setMainOpen(false);
    });
  }

  return (
    <>
      <IconButton
        ref={ref}
        onClick={() => {
          setMainOpen(true);
        }}
      >
        <Iconify icon="eva:eye-fill" width={25} height={25} />
      </IconButton>

      <Dialog
        open={mainOpen}
        onClose={() => {
          setMainOpen(false);
        }}
        fullWidth
        maxWidth={'10%'}
      >
        {!mainOpen ? (
          <DialogContent style={{ textAlign: 'center' }}>
            <CircularProgress

            />
          </DialogContent>
        ) : (
          <>
            <DialogTitle id="alert-dialog-title">{'Permission'}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" style={{ display: 'flex' }}>
                <TableContainer>
                  <div class="accordion" id="accordionPanelsStayOpenExample">
                    {
                      Object.keys(permissionList).map(e => {
                        return (
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                                {e}
                              </button>
                            </h2>
                            <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                              <div class="accordion-body">
                                {
                                  permissionList[e].map((e, i) => {
                                    return (
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id={"inlineCheckbox1" + i} checked={selectedList.some(el => el.permissionId === e.id)} onChange={(el) => {
                                          console.log()
                                          if (el.target.checked) {
                                            setSelectedList([...selectedList, {
                                              userId: id,
                                              permissionId: e.id
                                            }])
                                          } else {
                                            setSelectedList([...selectedList.filter(el => el.permissionId != e.id)])
                                          }

                                        }} value={e.id} />
                                        <label class="form-check-label" for={"inlineCheckbox1" + i}>{e.resource}</label>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }

                  </div>
                </TableContainer>
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ margin: 10 }}>
              <Button onClick={() => setMainOpen(false)} style={{ marginRight: 10 }}>
                Cancel
              </Button>
              <Button onClick={assignPermission} variant="outlined" style={{ marginRight: 10 }}>
                Save
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
